import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";



function CleaningSpecialties() {
  return (
    <div className="comp-list-home">
    </div>
  );
}

export default CleaningSpecialties;
